import { api } from '$$store/api';
import tasksHelpers from '$$store/tasks/helpers';
import columnsHelpers from '$$store/columns/helpers';
import resourcesHelpers from '$$store/resources/helpers';
import projectsHelpers from '$$store/projects/helpers';
import { prepareLogsData as prepareTimeLogsData } from '$$timeTrackingModel';
import userProjectConfigs from '$$userProjectConfigModel';

const prepareHistoryDataForGanttView = async (projectId, event) => {
  const response = await api.get(`/history/${event.azure_key}/event_id/${event.id}/gantt_id/${projectId}`);

  if (!response || !response.data || !response.data.ganttData) {
    return null;
  }

  const ganttData = response.data.ganttData;
  const result = {
    projectData: null,
    projectTasksData: null,
    сolumns: null,
    projectColumns: null,
    staticColumns: null,
    timeTrackingData: null,
    allResources: null,
    customDays: null,
  };

  if (ganttData.project) {
    const projectData = projectsHelpers.prepareInitProjects(ganttData.project);

    if (projectData.userConfig) {
      projectData.config = userProjectConfigs.mergeProjectConfigToUserConfig(projectData.config, projectData.userConfig);
    }

    result.projectData = projectData;
  }

  if (ganttData.tasks) {
    result.projectTasksData = tasksHelpers.prepareProjectTasksData(ganttData.tasks[0]);
  }

  if (ganttData.globalCustomColumnsData) {
    result.сolumns = columnsHelpers.prepareCustomColumnsData(ganttData.globalCustomColumnsData);
  }

  if (ganttData.userCustomColumnsData) {
    result.projectColumns = ganttData.userCustomColumnsData;
  }

  if (ganttData.customColumns) {
    result.staticColumns = columnsHelpers.prepareOptionsLocale(ganttData.customColumns);
  }

  if (ganttData.timeTrackingData) {
    result.timeTrackingData = prepareTimeLogsData(ganttData.timeTrackingData);
  }

  if (ganttData.resources) {
    result.allResources = resourcesHelpers.prepareResourceData(ganttData.resources);
  }

  if (ganttData.customDays) {
    result.customDays = ganttData.customDays.map(dayDataObject => ({
      ...dayDataObject,
      hours: typeof dayDataObject.hours === 'string' ? JSON.parse(dayDataObject.hours) : dayDataObject.hours,
    }));
  }

  return result;
};

export default {
  prepareHistoryDataForGanttView,
};
